<template>

  <div id='requestLogin'>

    <h1>Beställ inloggningsuppgifter</h1>
    <h3>Om du redan har registrerat dig och vill logga in för att ändra uppgifter, förlänga prenumerationen, avsluta prenumerationen, lägga in fler fordon eller skicka en manuell förfrågan.</h3>
    <input type="text" v-model="email" placeholder="Din e-post" />
    
    <button v-on:click="register">OK</button>

    <div class='messageWrapper'>
     <transition name="fade">
    <div class="message" v-if="result.length > 0" @click="result = ''" :style="error ? {'background': 'red'} : {'background': 'green'}"> {{ result }} </div>
    </transition>
    </div>

    

  </div>
</template>

<script>

import validator from './mixins/email'

const axios = require('axios');

export default {
  name: 'RequestLogin',
  props: {
  },
    mixins: [validator],

data: function () {
  return {
    email: "",
    condition: false,
    result: "",
    show: false,
    error: false
  }
},
    methods: {
        register: async function () {

            if (!this.validateEmail(this.email)){
                this.error = true;
                this.result = "Ogiltig epost";
                return;
            }

          

            axios.post(this.$hostname + '/requestlogin/', {
            
                        email:this.email
                    
            })
            .then(response => {

                if (response.data.status == "OK"){
                    
                    this.error = false;
                    this.name = "";
                    this.email = "";
                    this.condition = false;
                    this.result = response.data.message;
                    
                }else if (response.data.status == "FAIL"){
                    this.result = response.data.message;
                    this.error = true;
                }else{
                    alert(response.data);
                    this.result = "Kunde inte spara UI";
                    this.error = true;
                }

                
            })
            .catch(error =>  {
                alert("FAIL " + error);
                this.result = "FAIL"
                
            });   
        }
     }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

div#requestLogin{
    padding:20px;
    color:white;
    min-height:100px;
}


div#requestLogin input[type='text']{
  font-size:1.2em;
  width: calc(100% - 120px);
  border-radius: 10px;
   border:0px solid transparent;
   padding:10px;
   margin-right:10px;
  
}

div#requestLogin button{
    font-size:1.2em;
    border-radius: 10px;
    background-color:#2196f3;
    color:white;
    padding:10px;
    padding-left:20px;
    padding-right:20px;
    border:0px solid transparent;
  
}




.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>